import React from 'react'
import Link from '../../rich_text/link'

const Links = (props) => {
  return (
    <ul className={ props.className }>
      {(props.links || []).map((link, index) =>
        <li key={ index }>
          <Link { ...link } />
        </li>
      )}
    </ul>
  )
}

export default Links



// WEBPACK FOOTER //
// ./app/javascript/app/site/components/content/list/links/index.js